module.exports = __webpack_public_path__ + "img/logo.af3032d0.png";